import StatusBadge from "@/components/StatusBadge";

export const fxRateRefreshScheduleColumns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
      enableSorting: false,
    },
    {
      accessorKey: "time",
      header: "Time",
      enableSorting: false,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("time")}</div>
      ),
    },
  ];
};
